import { render, staticRenderFns } from "./CommonLabel.vue?vue&type=template&id=5ce6e1a1&scoped=true&"
import script from "./CommonLabel.vue?vue&type=script&lang=ts&"
export * from "./CommonLabel.vue?vue&type=script&lang=ts&"
import style0 from "./CommonLabel.vue?vue&type=style&index=0&id=5ce6e1a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce6e1a1",
  null
  
)

export default component.exports